import React, { useEffect, useState } from 'react'
import Reflux from 'reflux'
import Proxies from 'Components/proxies'
const { GET, POST } = Proxies
import DynamicTable from 'Components/dynamicTable'
import CollapsibleCard from 'Components/collapsibleCard'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link } from 'react-router-dom'
import { Button, ButtonGroup, CustomInput, Input, UncontrolledTooltip as Tooltip } from 'reactstrap'
import moment from 'moment'
import 'moment/locale/da'
import { toast } from 'react-toastify'

export const PageSectionList = () => {
  const [pageSections, setPageSections] = useState([])
  const [links, setLinks] = useState([])
  const [loading, setLoading] = useState(false)

  const getPageSections = async () => {
    setLoading(true)

    const responseJson = await GET('pageSections/pool')
    if (responseJson) {
      if (responseJson.error) {
        toast.error(`Fetching PageSections Failed: ${responseJson.error.message}`, {
          autoClose: 7500
        })
      } else {
        setPageSections(responseJson)
      }
    }

    setLoading(false)
  }

  const deletePageSection = async PageSectionID => {
    const responseJson = await POST('pageSections/removePageSection', { PageSectionID: PageSectionID })
    if (responseJson.error) {
      toast.error('Delete PageSection Failed', {
        autoClose: 7500
      })
    } else {
      setPageSections(pageSections.filter(ps => ps.PageSectionID !== PageSectionID))
      toast.success('PageSection Deleted', {
        autoClose: 7500
      })
    }
  }

  const getLinks = async () => {
    const responseJson = await GET('pageSections/getPageSectionLinksForBrand')
    if (responseJson) {
      if (responseJson.error) {
        toast.error(`Fetch links Failed: ${responseJson.error.message}`, {
          autoClose: 7500
        })
      } else {
        setLinks(responseJson)
      }
    }
  }

  const addLink = async PageSectionID => {
    const responseJson = await POST('pageSections/addBrandLink', { PageSectionID: PageSectionID })
    if (responseJson) {
      if (responseJson.error) {
        toast.error(`Fetch links Failed: ${responseJson.error.message}`, {
          autoClose: 7500
        })
      } else {
        setLinks([...links, { PageSectionID: PageSectionID, poolOrder: 0 }])
        toast.success(`Aktiverede sektion`, {
          autoClose: 7500
        })
      }
    }
  }

  const replaceLink = async (PageSectionID, poolOrder) => {
    const responseJson = await POST('pageSections/replaceBrandLink', {
      PageSectionID: PageSectionID,
      poolOrder: poolOrder
    })
    if (responseJson) {
      if (responseJson.error) {
        toast.error(`Replacing link Failed: ${responseJson.error.message}`, {
          autoClose: 7500
        })
      } else {
        const newLinks = links.map(l => {
          if (l.PageSectionID === PageSectionID) {
            return { ...l, poolOrder: poolOrder }
          } else {
            return l
          }
        })
        setLinks(newLinks)
        toast.success(`Opdaterede sektion`, {
          autoClose: 7500
        })
      }
    }
  }

  const removeLink = async PageSectionID => {
    const responseJson = await POST('pageSections/removeBrandLink', { PageSectionID: PageSectionID })
    if (responseJson) {
      if (responseJson.error) {
        toast.error(`Removing link Failed: ${responseJson.error.message}`, {
          autoClose: 7500
        })
      } else {
        const newLinks = links.filter(l => l.PageSectionID !== PageSectionID)
        setLinks(newLinks)
        toast.success(`Deaktiverede sektion`, {
          autoClose: 7500
        })
      }
    }
  }

  const canEdit = section => {
    const sessionBrandId = Reflux.GlobalState.LoginStore.settings ? Reflux.GlobalState.LoginStore.settings.BrandID : null
    return sessionBrandId === 9 || sessionBrandId === section.BrandID
  }

  useEffect(() => {
    getPageSections()
    getLinks()
  }, [])

  if (loading) {
    return <FontAwesomeIcon icon='spinner' spin />
  }

  return (
    <CollapsibleCard startOpen header={<strong>Forsidesektioner</strong>}>
      <DynamicTable
        responsive
        size='sm'
        options={{
          startSort: {
            dir: 'DESC',
            column: 'PageSectionID'
          },
          fieldFunctions: {
            active: e => {
              return (
                <CustomInput
                  type='checkbox'
                  id={`active${e.PageSectionID}`}
                  checked={links.some(l => l.PageSectionID === e.PageSectionID)}
                  onChange={v => {
                    if (v.target.checked) {
                      addLink(e.PageSectionID)
                    } else {
                      removeLink(e.PageSectionID)
                    }
                  }}
                />
              )
            },
            poolOrder: e => {
              return (
                <Input
                  type='number'
                  defaultValue={links.find(l => l.PageSectionID === e.PageSectionID)?.poolOrder}
                  onBlur={v => {
                    replaceLink(e.PageSectionID, Number(v.target.value))
                  }}
                  style={{ width: 100 }}
                />
              )
            },
            timeStart: e => {
              if (e.timeStart) {
                return moment(e.timeStart).format('DD-MM-YYYY ')
              }
            },
            timeEnd: e => {
              if (e.timeEnd) {
                return moment(e.timeEnd).format('DD-MM-YYYY')
              }
            }
          },
          fieldStringFunctions: {
            timeStart: e => {
              return moment(e.timeStart).format('x')
            },
            timeEnd: e => {
              return moment(e.timeEnd).format('x')
            }
          },
          addField: e => {
            return (
              <td>
                <ButtonGroup>
                  <Tooltip target={'edit' + e.PageSectionID}>Rediger</Tooltip>
                  <Button tag={Link} to={'/page-sections/' + e.PageSectionID} id={'edit' + e.PageSectionID} disabled={!canEdit(e)}>
                    <FontAwesomeIcon icon='edit' />
                  </Button>
                  <Tooltip target={'delete' + e.PageSectionID}>Slet</Tooltip>
                  <Button
                    id={'delete' + e.PageSectionID}
                    color='danger'
                    onClick={() => {
                      if (confirm('Vil du slette denne sektion?')) {
                        deletePageSection(e.PageSectionID)
                      }
                    }}
                    disabled={!canEdit(e)}
                  >
                    <FontAwesomeIcon icon='trash' />
                  </Button>
                </ButtonGroup>
              </td>
            )
          }
        }}
        headers={{
          PageSectionID: 'ID',
          BrandID: 'Brand ID',
          category: 'Kategori',
          title: 'Titel',
          active: 'Aktiv',
          poolOrder: 'Rækkefølge',
          timeStart: 'Start',
          timeEnd: 'Slut'
        }}
        data={pageSections}
      />
    </CollapsibleCard>
  )
}
